import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { AuthenticateUser } from '../../actions/cognito'
import FacebookLoginButton from './facebook-login-button'
import { Button, TextField, Paper } from '@material-ui/core'
import './styles.css'

class Login extends Component {
  constructor (props) {
    super(props)
    this.handleLogin = this.handleLogin.bind(this)
    this.state = {
      username: '',
      password: ''
    }
  }

  render () {
    return (
      <div className='login-background'>
        <div className='login-box'>
          <Paper elevation={1} className='login'>
              <div className='title'>Login - Mare Nostrum</div>
                <form className='form'>
                  <div className='data'>
                    <label htmlFor='txtEmail'>Email</label>
                    <TextField
                      type='text'
                      autoComplete='username email'
                      id='txtEmail'
                      value={this.props.username}
                      onChange={event => this.setState({ username: event.target.value })} />
                  </div>
                  <div className='data'>
                    <label htmlFor='txtPassword'>Password</label>
                    <TextField
                      type='password'
                      autoComplete='current-password'
                      id='txtPassword'
                      value={this.props.password}              
                      onChange={event => this.setState({ password: event.target.value })} />
                  </div>
                  <div className='actions'>
                    <Button variant='contained' color='primary' onClick={this.handleLogin} >Sign In</Button>
                    <Link to='/register'>Create a new account</Link>
                  </div>
                </form>
              <div className='devider'>
                <hr />
                <span>or sign in with your social account</span>
                <hr />
              </div>
              <div className='social'>
                <FacebookLoginButton />
              </div>
          </Paper>
        </div>
      </div>
    )
  }

  handleLogin () {
    this.props.authenticateUser(this.state.username, this.state.password)
      .catch(reason => {
        alert(reason.message)
      })
  }
}

const mapDispatch = (dispatch) => {
  return {
    authenticateUser: (username, password) => AuthenticateUser(username, password)(dispatch)
  }
}

const mapState = (state) => ({ })

export default connect(mapState, mapDispatch)(Login)
